module.exports = __webpack_public_path__ + "static/img/icon_defalut_yuer.030ade00.png";